import {LegacyWBIcon} from '@wandb/weave/common/components/elements/LegacyWBIcon';
import React, {useState} from 'react';
import {Button, Icon, Modal, type SemanticICONS} from 'semantic-ui-react';

interface DangerModalProps {
  yesText?: string;
  icon?: SemanticICONS;
  message?: React.ReactNode;
  trigger?: React.ReactElement;
  yes: any;
  open?: boolean;
  onClose?(): void;
}

const DangerModal: React.FC<DangerModalProps> = ({
  yesText,
  icon,
  message,
  trigger,
  yes,
  open,
  onClose,
}) => {
  const [modalOpen, setModalOpen] = useState(false);

  const handleOpen = () => setModalOpen(true);

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
    setModalOpen(false);
  };

  return (
    <Modal
      open={open == null ? modalOpen : open}
      onClose={handleClose}
      trigger={
        trigger
          ? React.cloneElement(trigger as any, {onClick: handleOpen})
          : undefined
      }
      size="small">
      <Modal.Header>
        <Icon name={icon || 'exclamation triangle'} /> Danger
      </Modal.Header>
      <Modal.Content>
        {message ?? <p>Are you absolutely sure?</p>}
      </Modal.Content>
      <Modal.Actions>
        <Button className="wb-icon-button" size="tiny" onClick={handleClose}>
          <LegacyWBIcon name="close" />
          Cancel
        </Button>
        <Button
          color="red"
          size="tiny"
          className="wb-icon-button"
          onClick={() => {
            if (yes) {
              yes();
            }
            handleClose();
          }}>
          <LegacyWBIcon name="check" style={{color: 'white'}} />{' '}
          {yesText || 'Yes'}
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default DangerModal;
